import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEn from './en/common.json';
import contentEn from './en/content.json';
import enumsEn from './en/enums.json';
import searchEn from './en/search.json';
import uiEn from './en/ui.json';
import workflowEn from './en/workflow.json';
import commonRu from './ru/common.json';
import contentRu from './ru/content.json';
import enumsRu from './ru/enums.json';
import searchRu from './ru/search.json';
import uiRu from './ru/ui.json';
import workflowRu from './ru/workflow.json';

const LANGUAGE_STORAGE_KEY = 'nuxeo-studio.language';
const DEFAULT_LANGUAGE = 'en';
const SUPPORTED_LANGUAGES = ['en', 'ru'] as const;

const normalizeLanguage = (language?: string | null): string => {
  const normalized = language?.toLowerCase().split('-')[0];
  return normalized &&
    SUPPORTED_LANGUAGES.includes(normalized as (typeof SUPPORTED_LANGUAGES)[number])
    ? normalized
    : DEFAULT_LANGUAGE;
};

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (savedLanguage) {
    return normalizeLanguage(savedLanguage);
  }

  return normalizeLanguage(window.navigator.language);
};

const syncDocumentMetadata = (language: string) => {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.lang = language;
  document.title = i18next.t('appTitle');
};

i18next
  .use(initReactI18next) // Для интеграции с React
  .init({
    resources: {
      en: {
        translation: {
          ...commonEn,
          ...uiEn,
          ...contentEn,
          ...workflowEn,
          ...searchEn,
        },
        enums: enumsEn,
      },
      ru: {
        translation: {
          ...commonRu,
          ...uiRu,
          ...contentRu,
          ...workflowRu,
          ...searchRu,
        },
        enums: enumsRu,
      },
    },
    lng: getInitialLanguage(), // Язык по умолчанию
    fallbackLng: 'en', // Язык, используемый при отсутствии перевода
    interpolation: {
      escapeValue: false, // Не экранировать HTML и строки по умолчанию
    },
  });

syncDocumentMetadata(normalizeLanguage(i18next.resolvedLanguage));

i18next.on('languageChanged', (language) => {
  const normalizedLanguage = normalizeLanguage(language);

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
  }

  syncDocumentMetadata(normalizedLanguage);
});

export default i18next;
